import { RootState } from 'store';

export const sel_vacancySended = (state: RootState) =>
  state.vacancy.isSended;
